import React from 'react';
import { iphoneRedeemCode, iphoneGolfStore } from '../link-actions';
import LogoText from '../components/logoText';

function PromoMidSection(props) {
    let promo = props.promo;
    return (<div className="row justify-content-center clearfix mt-3">
                    <div className="col-lg-6 col-12 text-center align-self-center p-2">
                        { promo ? <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                            <h4 className="heading-size" style={{ color: "white", margin:'15px 0 10px 0'}}>{promo.name}</h4>
                            
                            <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>{promo.description}</div>
                            <a href="#" onClick={() => iphoneRedeemCode(promo.code)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                
                            <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally {promo.normalPrice})</div>
                            <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends {promo.expires}</div>
                        </div> : 
                        <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                            <h4 className="heading-size" style={{ color: "white", margin:'15px 0 0px 0'}}>Try free for 7 days</h4>
                            
                            <a href="#" onClick={() => iphoneGolfStore("golf")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                            <div style={{ fontSize: '14px', lineHeight: "1.3", color: "white", marginBottom: '10px' }}>Cancel any time</div>
                                
                        </div>
}
                    </div>
                </div> 
    );
}

function PromoBestWayToTry(props) {
    let promo = props.promo;
    if(promo) {
return (<div className="row justify-content-center clearfix" style={{ background: 'url(./assets/img/smokebg_dark.png',  marginTop: '30px', padding: '25px 5px'}}>
                  <div className="col-12 text-center" style={{padding:"20px"}}>
                      <h2 className="heading-size" style={{ margin: "0 0 10px 0", color: 'yellowgreen' }}>The best way to try <LogoText light={true} /></h2>
                      <div style={{color:'white', fontSize:'24px', fontWeight:"normal", lineHeight:'2rem', marginBottom: '20px'}}>is with our {promo.name}</div>
                      <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>{promo.description}</div>
                        <a href="#" onClick={() => iphoneRedeemCode(promo.code)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                            
                        <div style={{ fontSize: '14px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>(Normally {promo.normalPrice})</div>
                        <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends {promo.expires}</div>
                  </div>
              </div>
    );
    } else {
        return <></>
    }
    
}

function PromoHeading(props) {
    let promo = props.promo;
    return (<>
    {promo ? <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                <h4 className="heading-size"style={{ color: "white", margin:'15px 0 10px 0'}}>{promo.name}</h4>
                
                    <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>{promo.description}</div>
                    <a href="#" onClick={() => iphoneRedeemCode(promo.code)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                        
                    <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally {promo.normalPrice})</div>
                    <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends {promo.expires}</div>
                    
            </div> :
            <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                <h4 className="heading-size" style={{ color: "white", margin:'15px 0 0px 0'}}>Try free for 7 days</h4>
                
                <a href="#" onClick={() => iphoneGolfStore("golf")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                <div style={{ fontSize: '14px', lineHeight: "1.3", color: "white", marginBottom: '10px' }}>Cancel any time</div>
                    
            </div>
            }</>
)
}

export {PromoMidSection, PromoBestWayToTry, PromoHeading};

